import { sanitizeString } from './sanitizeString';

export const sanitizeObject = (val) => {
  if (typeof val === 'string') return sanitizeString(val);
  if (Array.isArray(val)) return val.map(sanitizeObject);
  if (val !== null && typeof val === 'object') {
    return Object.fromEntries(
      Object.entries(val).map(([key, value]) => [key, sanitizeObject(value)])
    );
  }
  return val;
};

export default sanitizeObject;
